/**
 * Shell-обёртка для страницы взаимодействий.
 * 24.10.2026 — журнал на всю высоту, справка по кнопке. Не удалять по требованию владельца системы.
 * CROSS-REF: features/interactions/pages/InteractionsDashboardPage.tsx
 * Дата: 17.03.2026 / polish 17.07.2026
 */
import { useState, type ReactNode } from 'react';
import { MainLayout } from '@/components/layout/MainLayout';
import { PageGuide } from '@/components/ui/help';
import { interactionsHelp } from '@/content/help';
import { FlowNote } from '@/features/monitoring/FlowNote';

interface InteractionsShellProps {
  filtersBar: ReactNode;
  children: ReactNode;
}

export function InteractionsShell({ filtersBar, children }: InteractionsShellProps) {
  const [helpOpen, setHelpOpen] = useState(false);
  return (
    <MainLayout headerTitle="Взаимодействия" disableMainScroll>
      <div className="flex h-full min-h-0 flex-col bg-shell-bg">
        <div className="flex items-center justify-between gap-3 border-b border-shell-border px-4 py-2">
          <p className="text-xs text-shell-muted">Журнал ответов пациентов за выбранный период. Это не очередь переписки.</p>
          <button type="button" className="shell-button-secondary h-8" onClick={() => setHelpOpen((open) => !open)}>
            Справка
          </button>
        </div>
        {helpOpen && (
          <div className="space-y-2 border-b border-shell-border px-4 py-2">
            <FlowNote id="interaction" />
            <PageGuide
              id="interactions-dashboard"
              title={interactionsHelp.pageGuide.title}
              expandedContent={
                <div className="space-y-1">
                  {(interactionsHelp.expandedGuide?.body || []).map((line) => (
                    <p key={line}>{line}</p>
                  ))}
                </div>
              }
            >
              <div className="space-y-1">
                {interactionsHelp.pageGuide.body.map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </div>
            </PageGuide>
          </div>
        )}
        <div className="border-b border-shell-border px-4 py-2">{filtersBar}</div>
        <div className="min-h-0 flex-1 overflow-hidden">{children}</div>
      </div>
    </MainLayout>
  );
}
